export default __webpack_public_path__ + "static/media/logo-kwiks.38a3577b.png";